module.exports = __webpack_public_path__ + "img/emptyreviewdark.513997df.svg";